module.exports = __webpack_public_path__ + "img/dracula-5.ea0efd71.jpg";